<template>
    <el-dropdown class="avatar-container"
        trigger="click">
        <div class="avatar-wrapper">
            <span>{{currentUser.name}} ({{currentUser.type | userTypeChar}}, {{currentUser.loginName}}, {{currentUser.id}})</span>
            <i class="el-icon-caret-bottom" />
        </div>

        <el-dropdown-menu slot="dropdown" class="user-dropdown">
            <el-dropdown-item>
                <span style="display:block;">当前用户 {{currentUser.name}} ({{currentUser.type | userTypeChar}}, {{currentUser.loginName}}, {{currentUser.id}})</span>
            </el-dropdown-item>

            <el-dropdown-item>
                <a :href="'/ticket-vue/u?id=' + this.currentUser.id" target="_blank">个人信息</a>
            </el-dropdown-item>

            <el-dropdown-item>
                <a @click="goUserDepartment">部门和上下级</a>
            </el-dropdown-item>
            <el-dropdown-item>
                <a @click="goRolePermission">角色权限信息</a>
            </el-dropdown-item>
            <el-dropdown-item>
                <a @click="goOrganization">企业(租户)信息</a>
            </el-dropdown-item>
            <el-dropdown-item>
                <a @click="showUserNotifyConfig">通知设置</a>
            </el-dropdown-item>
            <el-dropdown-item>
                <a @click="clearCache">清理缓存</a>
            </el-dropdown-item>
            <el-dropdown-item>
                <a @click="goHelp">帮助</a>
            </el-dropdown-item>
            <el-dropdown-item>
                <a @click="goYijian">意见反馈</a>
            </el-dropdown-item>
            <el-dropdown-item>
                <a @click="goAbout">关于系统</a>
            </el-dropdown-item>

            <el-dropdown-item>
                <a href="/ticket">主页</a>
            </el-dropdown-item>

            <el-dropdown-item>
                <a @click="goLogout">退出登录</a>
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
import EventBus from '@/assets/EventBus.js';

export default {
    name : 'CurrentUser',

    data() {
        return {
          currentUser : {}
        };
    },

    mounted() {
        var _this = this;

        // {"id":309,"loginName":"43f780146","name":"果酒2店:果酒2店","type":"MerchantUser"}
        // {"id":831,"loginName":"lmw","mail":"416133823@qq.com","name":"黎明伟","phone":"13699466308","type":"SystemUser"}
        // {"id":588872,"loginName":"941203005","name":"941203005","type":"TjkUser"}

        sdk.TicketUserApi().currentUserCached().then(res => {
            if ( !res ) {
                location.href = '/ticket-vue/login?130';
                return;
            }

            _this.currentUser = res;

            // 非后台用户
            if ( 'SystemUser' == res.type ) {
                console.log('#75 showIfSystemUser', res);
                _this.showIfSystemUser();
            }
        });
    },

    methods : {
        goUserDepartment() {
            alert('我所在的部门 和 我的上下级, 开发中');
        },

        goRolePermission() {
            alert('我的角色和权限, 开发中');
        },

        clearCache() {
            if ( !confirm('确定要清理缓存?') ) {
                return;
            }

            CacheUtil.clearCache();
        },

        showUserNotifyConfig() {
            EventBus.$emit('showUserNotifyConfig');
        },

        goOrganization() {
            window.open("/ticket-vue/organization");
        },

        goHelp() {
            window.open("/ticket/h");
        },

        goYijian() {
            window.open("/ticket/h");
        },

        goAbout() {
            window.open("/ticket-vue/about");
        },

        goLogout() {
            if ( !confirm('退出登陆?') ) {
                return;
            }

            this.$store.dispatch('LogOut').then(() => {
              if(window.location.href.indexOf('feige') > 0) {
                location.href = '/ticket-vue/feige/merchant/index?52';
              }else {
                location.href = '/ticket-vue/login?177';
              }
            });
        },

        showIfSystemUser() {
            var _show_if_system_user_1 = function() {
                $('.el-submenu, .dl').each(function() {
                    if ( '工单设置' == $(this).text().trim() ) {
                        $(this).show(); // show 工单设置按钮
                    }
                });

                $('.hide-if-not-system-user').show();

                // show Dashboard
                $('#tab-Dashboard').show();
            };

            setTimeout(_show_if_system_user_1, 1);
            setTimeout(_show_if_system_user_1, 500);
            setTimeout(_show_if_system_user_1, 2000);
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ticket/CurrentUser.vue